import { render, staticRenderFns } from "./ListViewSelector.vue?vue&type=template&id=20d4ac92&"
import script from "./ListViewSelector.vue?vue&type=script&lang=js&"
export * from "./ListViewSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/boligvelger-v4/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20d4ac92')) {
      api.createRecord('20d4ac92', component.options)
    } else {
      api.reload('20d4ac92', component.options)
    }
    module.hot.accept("./ListViewSelector.vue?vue&type=template&id=20d4ac92&", function () {
      api.rerender('20d4ac92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ListViewSelector.vue"
export default component.exports